// extracted by mini-css-extract-plugin
export default {"root":"PlasmicLoginButton_root__xV6i1","text":"PlasmicLoginButton_text__JwczM"};